import * as Yup from "yup";
 
const SitumSettingValidation = Yup.object().shape({
    baseurl: Yup.string().required("Base url is required"),
    apikey : Yup.string().required("Api key is required"),
    buildingid : Yup.number().required("Building id is required"),
    floorid:Yup.number().required("Floor id is required")
});
export default SitumSettingValidation;